/** Raw Seed Release — the desk's list, grouped by TRID. */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { PlantRequired } from "@/components/app/plant-required";
import { useAuth } from "@/features/auth/store";
import { ReleaseListPage } from "@/features/warehouse/components/release-list-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

const search = z.object({
  tab: z.enum(["released", "cancelled"]).default("released"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/warehouse/$stage/release/")({
  validateSearch: search,
  beforeLoad: ({ params }) => guardDesk(params.stage),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const canRelease = useAuth((a) => a.can("warehouse.release"));
  const canCancel = useAuth((a) => a.can("warehouse.release.cancel"));
  const facilityId = useDeskFacility();
  if (facilityId === undefined)
    return <PlantRequired title="Raw Seed Release" what="The release list" />;
  return (
    <ReleaseListPage
      stage={asStage(stage)}
      facilityId={facilityId}
      search={s}
      canRelease={canRelease}
      canCancel={canCancel}
      onSearch={(next) =>
        // Any change but the page's own starts again at page 1.
        void navigate({ search: (prev) => ({ ...prev, page: 1, ...next }) })
      }
    />
  );
}
